
import { connect } from 'react-redux';
import StoveAndLigthingSelectionPage from '../components/StoveAndLigthingSelectionPage';

const mapDispatchToProps = (dispatch, ownProps) => ({
   
});

const mapStateToProps = (state, ownProps) => {
    return {
        materialImage: state.materialImage.image,
        previousMaterialImage: state.materialImage.previousImage,
        loading: state.materialImage.isLoading,   
        nextPage: ownProps.nextPage,
        showPrices: state.clientConfiguration.showPrices
      
    };
};

const StoveAndLigthingSelectionPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(StoveAndLigthingSelectionPage);

export default StoveAndLigthingSelectionPageContainer;
